import React, { useState } from "react";
import Crosole from "../../Crosole/Crosole";
import "./Home.css";
import { FaTruck, FaShippingFast } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import  ContactModal from "../Contact us/Contact"

const Home = () => {
    const [showModal, setShowModal] = useState(false);
  
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);
  return (
    <>
      <div style={{ background: " rgb(250, 245, 245)" }}>
        <Crosole />
        <div className="crosole-container">
          <h4>We are a trusted partner in simplifying logistics</h4>
          <p>
            Our aim is to streamline the logistics process - offering a smooth
            and efficient delivery experience, all
            <br /> while delivering excellent value by offering the lowest cost.
          </p>
        </div>
        {/* Services Section */}
        <div className="container bg-white p-4 rounded shadow demo">
          <div className="row text-center">
            {/* Column 1 */}
            <div className="col-6 col-md-3 stat-box">
              <FaTruck className="service-icon" />
              <div>
                <h5 className="stat-value">3k+</h5>
                <p className="stat-text">Partners</p>
              </div>
            </div>

            {/* Column 2 */}
            <div className="col-6 col-md-3 stat-box">
              <FaLocationDot className="service-icon" />
              <div>
                <h5 className="stat-value">6k+</h5>
                <p className="stat-text">PIN codes served</p>
              </div>
            </div>

            {/* Column 3 */}
            <div className="col-6 col-md-3 stat-box">
              <FaShippingFast className="service-icon" />
              <div>
                <h5 className="stat-value">9 Lac+</h5>
                <p className="stat-text">Orders shipped per day</p>
              </div>
            </div>

            {/* Column 4 */}
            <div className="col-6 col-md-3 stat-box">
              <FaRegHandshake className="service-icon" />
              <div>
                <h5 className="stat-value">30k+</h5>
                <p className="stat-text">Delivery executives</p>
              </div>
            </div>
          </div>
        </div>
        {/* First Join Us Section */}
        <div className="container mt-5">
          <div className="row align-items-center">
            {/* Left Side - Image */}
            <div className="col-12 col-md-6 text-center">
              <img
                src="https://www.valmo.in/static-assets/valmo-web/valmo-delivery-to-customer.jpg?w=256"
                alt="Delivery Executive"
                style={{ maxWidth: "100%", borderRadius: "10px" }} // Image को बड़ा किया गया है
              />
            </div>

            {/* Right Side - Text */}
            <div className="col-12 col-md-5">
              {" "}
              {/* Reduced the width from 6 to 5 columns on medium and larger screens */}
              <div
                className="border rounded p-4 p-md-5 shadow"
                style={{ minHeight: "500px" }} // Maintain height
              >
                <h4 className="fw-bold text-center text-md-start">
                  Join us as Delivery Executive
                </h4>

                <ul
                  className="text-center text-md-start"
                  style={{ paddingLeft: "20px" }}
                >
                  <li style={{ marginBottom: "10px" }}>
                    Sign up to do both pick-up and delivery services across
                    India.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Earn a sustainable income flexibly and provide the best
                    experience.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    This program has enabled over{" "}
                    <strong>30,000+ partners</strong> across India till date.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Join us to start working with India’s fastest-growing
                    logistics company.
                  </li>
                </ul>

                <div className="text-center text-md-start">
                  <button className="btn btn-primary mt-2"onClick={handleShow}>Join Us Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Add a margin to separate the two sections */}
        <div className="my-1"></div>
        {/* Second Join Us Section */}
        <div className="container mt-5">
          <div className="row align-items-center">
            {/* Left Side - Text */}
            <div className="col-12 col-md-5">
              {" "}
              {/* Reduced the width from 6 to 5 columns on medium and larger screens */}
              <div
                className="border rounded p-4 p-md-5 shadow"
                style={{ minHeight: "500px" }} // Maintain height
              >
                <h4 className="fw-bold text-center text-md-start">
                  Join us as Delivery Executive
                </h4>

                <ul
                  className="text-center text-md-start"
                  style={{ paddingLeft: "20px" }}
                >
                  <li style={{ marginBottom: "10px" }}>
                    Sign up to do both pick-up and delivery services across
                    India.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Earn a sustainable income flexibly and provide the best
                    experience.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    This program has enabled over{" "}
                    <strong>30,000+ partners</strong> across India till date.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Join us to start working with India’s fastest-growing
                    logistics company.
                  </li>
                </ul>

                <div className="text-center text-md-start">
                  <button className="btn btn-primary mt-2"onClick={handleShow}>Join Us Now</button>
                </div>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="col-12 col-md-6 text-center">
              <img
                src="https://www.valmo.in/static-assets/valmo-web/valmo-delivery-group.jpg?w=256"
                alt="Delivery Executive"
                className="img-fluid"
                style={{ maxWidth: "100%", borderRadius: "20px" }} // Border Radius को कम किया गया है
              />
            </div>
          </div>
        </div>
      </div>
      {/* Add a margin to separate the two sections */}
      <div className="my-5"></div>
        {/* ContactModal Component */}
        <ContactModal show={showModal} handleClose={handleClose} />
    
    </>
  );
};

export default Home;
